import axios from "axios";

export function updateScreenById(token, screenId) {
    return axios.post(
        process.env.REACT_APP_API_URL + '/updateScreenById',
        { screenId: Number(screenId) },
        {
            headers: {
                Authorization: `${token}`,
                'Content-Type': 'application/json',
            },
        }
    );
}
